import React, { useRef, useState } from "react";
import videoStyles from "./video.module.css";
import { isApiFileUrl, resolveFileUrl } from "../../utils/fileUrl";

const Video: React.FC<{ src: string }> = ({ src }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState<boolean>(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const resolvedSrc = resolveFileUrl(src);
  const crossOrigin = isApiFileUrl(resolvedSrc) ? "use-credentials" : undefined;

  return (
    <>
      <video
        ref={videoRef}
        src={resolvedSrc}
        crossOrigin={crossOrigin}
        className={videoStyles.video}
      />
      <button
        className={`${videoStyles.playBtn} ${
          isPlaying && videoStyles.isPlaying
        }`}
        onClick={togglePlay}
      />
    </>
  );
};

export default Video;
